﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

//No internet
require('typeahead-addresspicker');

import tpl_register from './tpl/register.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import config from '../../../common/config';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import * as Entities_PublicRecaptchaRegister from '../../entities/publicRecaptchaRegister';  

//import * as Validate_vat from 'validate-vat';
var validate_vat = require('validate-vat');

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_register({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;
        this.price_localSetting = this.options.price_localSetting;

        

        this.informationCollection = new Entities_Empty.Collection();

        this.localSetting = new Entities_Empty.Model();
    },
    test : function() {
        this.model.attributes.FirstName = 'Steen';
        this.model.attributes.Phone = '121212';
        this.model.attributes.Email = 'steenhansenden@gmail.com';
        this.model.attributes.Password =  'qweQWE123!';
        this.model.attributes.PasswordConfirm = 'qweQWE123!';
        this.model.attributes.Address = 'Lille Roldvej 1, 5492 Vissenbjerg, Danmark';

        this.ui.register_inputFirstName.val(this.model.attributes.FirstName);
        this.ui.register_inputPhone.val(this.model.attributes.Phone);
        this.ui.register_inputEmail.val(this.model.attributes.Email);
        this.ui.register_inputPassword.val(this.model.attributes.Password);
        this.ui.register_inputPasswordConfirm.val(this.model.attributes.PasswordConfirm);
        this.ui.register_inputAddress.val(this.model.attributes.Address);
    },
    regions: {
        information: "#registerInformation"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app : this.app }));
    },
    ui: {
        'register_inputName': '#register_inputName',
        'register_inputContactperson_Name': '#register_inputContactperson_Name',
        'register_inputContactperson_Phone': '#register_inputContactperson_Phone',
        //'register_inputContactperson_Email': '#register_inputContactperson_Email',
        'register_inputAddress01': '#register_inputAddress01',
        'register_inputAddress01_Supplement': '#register_inputAddress01_Supplement',
        'register_inputAddress02': '#register_inputAddress02',
        'register_inputAddress02_Supplement': '#register_inputAddress02_Supplement',

        'register_btnGoogle': '#register_btnGoogleFind',
        'register_inputAddress': '#register_inputAddress',
        'register_inputFirstName': '#register_inputFirstName',
        'register_inputSecondName': '#register_inputSecondName',
        'register_inputPhone': '#register_inputPhone',
        'register_inputAddressSupplement': '#register_inputAddressSupplement',
        'register_inputEmail' : '#register_inputEmail',
        'register_inputPassword' : '#register_inputPassword',
        'register_inputPasswordConfirm' : '#register_inputPasswordConfirm',
        'register_restart' : '#register_restart',
        'register_btnSubmit': '#register_btnSubmit',
        'register_pCondition': '#register_pCondition',
        'register_p_verifyOK' : '#register_p_verifyOK'
    },
    events: {
        'click #register_btnSubmit': 'btnSubmitClick',
        'click #register_btnChangePassword': 'btnChangePassword',
        'click #register_btnGoogleSubmit': 'btnGoogleFind',
        'click #register_restart': 'btnRestartClick'
    },
    onRender: function () {
    },
    onAttach(){
        var self = this;
        
        this.addressPicker01 = new AddressPicker();
        this.ui.register_inputAddress01.typeahead(null, {
            displayKey: 'description',
            source: self.addressPicker01.ttAdapter()
        });

        this.addressPicker01.bindDefaultTypeaheadEvent(this.ui.register_inputAddress01);
        $(this.addressPicker01).on('addresspicker:selected', function (event, parsedGeocodeResult) {
            var _parsedGeocodeResult = self._parseGeocodeResult(parsedGeocodeResult.placeResult);
            if (_parsedGeocodeResult.type != "street_address") {
            }
            else {
                self.setModel(_parsedGeocodeResult, null);
            }
            self.updateInformationCollection();
        });

        this.addressPicker02 = new AddressPicker();
        this.ui.register_inputAddress02.typeahead(null, {
            displayKey: 'description',
            source: self.addressPicker02.ttAdapter()
        });

        this.addressPicker02.bindDefaultTypeaheadEvent(this.ui.register_inputAddress02);
        $(this.addressPicker02).on('addresspicker:selected', function (event, parsedGeocodeResult) {
            var _parsedGeocodeResult = self._parseGeocodeResult(parsedGeocodeResult.placeResult);
            if (_parsedGeocodeResult.type != "street_address") {
            }
            else {
                self.setModel(null, _parsedGeocodeResult);
            }
            self.updateInformationCollection();
        });


        //this.test();
    },
    loadCaptcha: function() {
        var self = this;
        var getRecaptchaResponse = function(response) {
            var data = {
                response: response
            }

            //var recaptchaModel = new Entities_PublicRecaptchaRegister.Model();
            self.model.attributes.response = response;
            //recaptchaModel.attributes.Id = -1;

            self.model.save(self.attributes, {
                route : 'register',
                silent: true,
                wait:true,
                //dataType: 'text',
                success: function (mode, response) {
                    window.app.router.navigate(response.Url);
                    window.app.router.messageWithName(response.HeaderNumber, response.TitleNumber, response.Name, true);
                },
                error: function (mode, response) {
                    //window.app.router.navigate("#price");
                    //window.app.router.price();
                }
            });
        };

        var renderCaptcha = function() {
            self.captchaWidgetId = grecaptcha.render('recaptcha-container', {
                sitekey : config.googleRecaptchaSiteKey(),
                callback: getRecaptchaResponse
            });
        };

        window.renderCaptcha = renderCaptcha;

        $.getScript('https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit', function() { });
    },
    //inputAddressChange: function (event) {
    //    var _parsedGeocodeResult = self._parseGeocodeResult(self.ui.register_inputAddress.val());

    //    if (_parsedGeocodeResult.type != "street_address") {
    //        self.model.attributes.WrongAddress = false;
    //    }
    //    else {
    //        self.model.attributes.WrongAddress = true;

    //        self.setModel(_parsedGeocodeResult);
    //    }
    //},
    onDestroy(){
        $(this.addressPicker01).unbind();
        $(this.addressPicker02).unbind();
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No registerYet yet
        /*if (this.model.validateNoBackbone(this.model.attributes, this.app)) {
            var tmpModel = new this.informationCollection.model({ Information: resources.X100333 });
            this.informationCollection.add(tmpModel);
        }*/

        //Address is wrong
        /*if (this.model.attributes.Address_lat == 0 || this.model.attributes.Address_lat == 0 ||
            this.model.attributes.Address_lat == null || this.model.attributes.Address_lat == null) {
            var tmpModel = new this.informationCollection.model({ Information: resources.X100287 });
            this.informationCollection.add(tmpModel);
        }*/
    },
    updateInformationCollection: function () {
        /*this.renderInformation();
        this.informationCollection.trigger('change');*/
    },
    btnSubmitClick: function (event) {
        var self = this;
        this.hideErrors();

        if (event != null) {
            event.preventDefault();
        }

        if (this.setModel()) {
            var callback = function () {
                self.loadCaptcha();
                self.ui.register_p_verifyOK.show();
                self.ui.register_btnSubmit.css('display', 'none');
            }

            var acceptTermsOfTrade = function(ret) {
                if (ret == true) {
                    var href = config.webApiUrl() + '/index.html#termsOfTrade';
                    var html = '<a target="_blank" href="' + href + '">' + resources.X200202 + '<a/>';
                    var text = String.format(resources.X200203, html);

                    var dialog2ButtonModel = new Entities_Empty.Model();
                    dialog2ButtonModel.attributes.Title = resources.X200090;
                    dialog2ButtonModel.attributes.Text = text;
                    dialog2ButtonModel.attributes.Button01 = resources.X200204;
                    dialog2ButtonModel.attributes.Button02 = resources.X200096;
        
                    var dialog2Button = new View_Dialog2Button({ model: dialog2ButtonModel });

                    var callback01 = function () {
                        dialog2Button.triggerMethod('dialog:close');
                        self.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
                        self.stopListening(dialog2Button, "dialog:btn02clicked", callback02);
                        dialog2Button.triggerMethod('dialog:close');

                        callback();
                    }
                    self.listenTo(dialog2Button, "dialog:btn01clicked", callback01);

                    var callback02 = function () {
                        self.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
                        self.stopListening(dialog2Button, "dialog:btn02clicked", callback02);
                        dialog2Button.triggerMethod('dialog:close');
                    }
                    self.listenTo(dialog2Button, "dialog:btn02clicked", callback02);

                    self.app.dialogRegion.show(dialog2Button);
                } else  {
                    self.showErrors(self.model.errors);
                    $('html,body').scrollTop(0);
                } 
            }

            this.model.validateNoBackbone(this.model.attributes, this.app, acceptTermsOfTrade);
        }
    },
    btnRestartClick: function (event) {
        window.app.router.navigate("#price");
        window.app.router.price();
    },
    setModel: function (parsedGeocodeResult01, parsedGeocodeResult02 ) {
        
        var administrative_area_level_1_01 = '';
        var administrative_area_level_2_01 = '';
        var administrative_area_level_3_01 = '';
        var country_01 = '';
        var countryKey_01 = '';
        var lat_01 = 0;
        var lng_01 = 0;
        var locality_01 = '';
        var postal_code_01 = '';
        var route_01 = '';
        var street_number_01 = '';
        var sublocality_01 = '';

        if (parsedGeocodeResult01) {
            //this.ui.register_inputAddress.val(parsedGeocodeResult.formatted_address);

            if (parsedGeocodeResult01.administrative_area_level_1 != false) {
                administrative_area_level_1_01 = parsedGeocodeResult01.administrative_area_level_1;
            }
            if (parsedGeocodeResult01.administrative_area_level_2 != false) {
                administrative_area_level_2_01 = parsedGeocodeResult01.administrative_area_level_2;
            }
            if (parsedGeocodeResult01.administrative_area_level_3 != false) {
                administrative_area_level_3_01 = parsedGeocodeResult01.administrative_area_level_3;
            }
            if (parsedGeocodeResult01.country != false) {
                country_01 = parsedGeocodeResult01.country;
            }
            if (parsedGeocodeResult01.lat != false) {
                lat_01 = parsedGeocodeResult01.lat;
            }
            if (parsedGeocodeResult01.lng != false) {
                lng_01 = parsedGeocodeResult01.lng;
            }
            if (parsedGeocodeResult01.locality != false) {
                locality_01 = parsedGeocodeResult01.locality;
            }
            if (parsedGeocodeResult01.postal_code != false) {
                postal_code_01 = parsedGeocodeResult01.postal_code;
            }
            if (parsedGeocodeResult01.route != false) {
                route_01 = parsedGeocodeResult01.route;
            }
            if (parsedGeocodeResult01.street_number != false) {
                street_number_01 = parsedGeocodeResult01.street_number;
            }
            if (parsedGeocodeResult01.sublocality != false) {
                sublocality_01 = parsedGeocodeResult01.sublocality;
            }

            if (parsedGeocodeResult01.countryKey != false) {
                countryKey_01 = parsedGeocodeResult01.countryKey;
            }
        }

        var administrative_area_level_1_02 = '';
        var administrative_area_level_2_02 = '';
        var administrative_area_level_3_02 = '';
        var country_02 = '';
        var countryKey_02 = '';
        var lat_02 = 0;
        var lng_02 = 0;
        var locality_02 = '';
        var postal_code_02 = '';
        var route_02 = '';
        var street_number_02 = '';
        var sublocality_02 = '';

        if (parsedGeocodeResult01) {
            //this.ui.register_inputAddress.val(parsedGeocodeResult.formatted_address);

            if (parsedGeocodeResult01.administrative_area_level_1 != false) {
                administrative_area_level_1_02 = parsedGeocodeResult01.administrative_area_level_1;
            }
            if (parsedGeocodeResult01.administrative_area_level_2 != false) {
                administrative_area_level_2_02 = parsedGeocodeResult01.administrative_area_level_2;
            }
            if (parsedGeocodeResult01.administrative_area_level_3 != false) {
                administrative_area_level_3_02 = parsedGeocodeResult01.administrative_area_level_3;
            }
            if (parsedGeocodeResult01.country != false) {
                country_02 = parsedGeocodeResult01.country;
            }
            if (parsedGeocodeResult01.lat != false) {
                lat_02 = parsedGeocodeResult01.lat;
            }
            if (parsedGeocodeResult01.lng != false) {
                lng_02 = parsedGeocodeResult01.lng;
            }
            if (parsedGeocodeResult01.locality != false) {
                locality_02 = parsedGeocodeResult01.locality;
            }
            if (parsedGeocodeResult01.postal_code != false) {
                postal_code_02 = parsedGeocodeResult01.postal_code;
            }
            if (parsedGeocodeResult01.route != false) {
                route_02 = parsedGeocodeResult01.route;
            }
            if (parsedGeocodeResult01.street_number != false) {
                street_number_02 = parsedGeocodeResult01.street_number;
            }
            if (parsedGeocodeResult01.sublocality != false) {
                sublocality_02 = parsedGeocodeResult01.sublocality;
            }

            if (parsedGeocodeResult01.countryKey != false) {
                countryKey_02 = parsedGeocodeResult01.countryKey;
            }
        }

        this.model.set({
            Name: this.ui.register_inputName.val(),
            Contactperson_Name: this.ui.register_inputContactperson_Name.val(),
            Contactperson_Phone: this.ui.register_inputContactperson_Phone.val(),
            Contactperson_Email: '',//this.ui.register_inputContactperson_Email.val(),
            Address01_Supplement: this.ui.register_inputAddress01_Supplement.val(),
            Address02_Supplement: this.ui.register_inputAddress02_Supplement.val(),
            CultureName: config.cultureName(),
            AccountVerify: 0,
            Deleted: false,   
            ExternalSystem : "",
            Email: this.ui.register_inputEmail.val(),
            Password: this.ui.register_inputPassword.val(),
            PasswordConfirm: this.ui.register_inputPasswordConfirm.val(),
            //UtcDate : utcDateTime,
            Address01: this.ui.register_inputAddress01.val(),
            AddressSupplement01: this.ui.register_inputAddress01_Supplement.val(),
            Address01_administrative_area_level_1: administrative_area_level_1_01,
            Address01_administrative_area_level_2: administrative_area_level_2_01,
            Address01_administrative_area_level_3: administrative_area_level_3_01,
            Address01_country: country_01,
            Address01_countryKey: countryKey_01,
            Address01_lat: lat_01,
            Address01_lng: lng_01,
            Address01_locality: locality_01,
            Address01_postal_code: postal_code_01,
            Address01_route: route_01,
            Address01_street_number: street_number_01,
            Address01_sublocality: sublocality_01,
            Address02: this.ui.register_inputAddress02.val(),
            AddressSupplement02: this.ui.register_inputAddress02_Supplement.val(),
            Address02_administrative_area_level_1: administrative_area_level_1_02,
            Address02_administrative_area_level_2: administrative_area_level_2_02,
            Address02_administrative_area_level_3: administrative_area_level_3_02,
            Address02_country: country_02,
            Address02_countryKey: countryKey_02,
            Address02_lat: lat_02,
            Address02_lng: lng_02,
            Address02_locality: locality_02,
            Address02_postal_code: postal_code_02,
            Address02_route: route_02,
            Address02_street_number: street_number_02,
            Address02_sublocality: sublocality_02,
            Custom_Color_Default: '#CDCDCD',
            SolidColor_Color_Off: '#000000',
            SolidColor_Color_Busy: '#FF0000',
            SolidColor_Color_Available: '#00FF00',
            SolidColor_Color_Blue: '#0000FF',
            SolidColor_Color_Yellow: '#FFFF00',
            SolidColor_Color_Cyan: '#00FFFF',
            SolidColor_Color_Magenta: '#FF00FF',
            SolidColor_Color_CustomColor: '#00FF00',
            MSTeams_Color_Online: '#008000',
            MSTeams_Color_Busy: '#FF0000',
            MSTeams_Color_DoNotDisturb: '#800080',
            MSTeams_Color_BeRightBack: '#FF9600',
            MSTeams_Color_ShowAsNotPresent: '#FF9600',
            MSTeams_Color_ShowAsOffline: '#CCCCCC',
            Mutebutton_Color_On: '#00FF00',
            Mutebutton_Color_Off: '#FF0000',
            Pomodoro_Color_Time: '#FF0000',
            Pomodoro_Color_ShortBreak: '#00FF00',
            Pomodoro_Color_LongBreak: '#FFFF00',
            Custom_Text_Default: resources.X200311,
            SolidColor_Text_Off: resources.X200163,
            SolidColor_Text_Busy: resources.X200164,
            SolidColor_Text_Available: resources.X200165,
            SolidColor_Text_Blue: resources.X200166,
            SolidColor_Text_Yellow: resources.X200167,
            SolidColor_Text_Cyan: resources.X200168,
            SolidColor_Text_Magenta: resources.X200169,
            SolidColor_Text_CustomColor: resources.X200175,
            MSTeams_Text_Online: resources.X200304,
            MSTeams_Text_Busy: resources.X200305,
            MSTeams_Text_DoNotDisturb: resources.X200306,
            MSTeams_Text_BeRightBack: resources.X200307,
            MSTeams_Text_ShowAsNotPresent: resources.X200308,
            MSTeams_Text_ShowAsOffline: resources.X200309,
            Mutebutton_Text_On: resources.X200313,
            Mutebutton_Text_Off: resources.X200314,
            Pomodoro_Text_Time: resources.X200315,
            Pomodoro_Text_ShortBreak: resources.X200316,
            Pomodoro_Text_LongBreak: resources.X200317,
            Text01: resources.X200205,
            Text02: resources.X200206,
            Text03: resources.X200207,
            Text04: resources.X200208,
            Text05: resources.X200209,
        });
        
        return true;
    },
    save: function () {
        var self = this;
        this.hideErrors();

        var callback = function (ret) {
            if (ret == false) {
                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X200210;
                dialogWaitingModel.attributes.Text = resources.X200211;
                dialogWaitingModel.attributes.Button = resources.X200025;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

        
                self.model.save(self.model.attributes, {
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');
                    }
                });
            } else  {
                self.showErrors(self.model.errors);
                $('html,body').scrollTop(0);
            } 
        }

        this.model.validateNoBackbone(this.model.attributes, this.app, callback);
    },
    _parseGeocodeResult: function (geocodeResult) {
        this._addressParts = {
            street_number: null, route: null, locality: null, sublocality: null,
            administrative_area_level_3: null, administrative_area_level_2: null,
            administrative_area_level_1: null, country: null, postal_code: null, type: null
        };

        this._addressPartsShort = {
            street_number: null, route: null, locality: null, sublocality: null,
            administrative_area_level_3: null, administrative_area_level_2: null,
            administrative_area_level_1: null, country: null, postal_code: null, type: null
        };

        this._parseLatAndLng = function (location) {
            var longitude, latitude;

            if (typeof (location.lat) === 'function') {
                latitude = location.lat();
                longitude = location.lng();
            } else {
                latitude = location.lat;
                longitude = location.lng;
            }

            return { lat: latitude, lng: longitude };
        };

        this._findInfo = function (result, type) {
            for (var i = 0; i < result.address_components.length; i++) {
                var component = result.address_components[i];
                if (component.types.indexOf(type) != -1) {
                    return component.long_name;
                }
            }
            return false;
        };

        this._findInfoShort = function (result, type) {
            for (var i = 0; i < result.address_components.length; i++) {
                var component = result.address_components[i];
                if (component.types.indexOf(type) != -1) {
                    return component.short_name;
                }
            }
            return false;
        };

        var parsed = this._parseLatAndLng(geocodeResult.geometry.location);
        var parsedShort = this._parseLatAndLng(geocodeResult.geometry.location);

        for (var addressPart in this._addressParts) {
            parsed[addressPart] = this._findInfo(geocodeResult, addressPart);
        }

        for (var addressPart in this._addressParts) {
            parsedShort[addressPart] = this._findInfoShort(geocodeResult, addressPart);
        }

        parsed.type = geocodeResult.types[0];
        parsed.formatted_address = geocodeResult.formatted_address;

        parsed.countryKey = parsedShort.country;

        return parsed;
    }
}, Backbone.Radio.Requests);
